import { getConfig } from "@/config/app.config";

const API_URL = getConfig().publicApiUrl;

type SearchLogPayload = {
  query: string;
  resultCount: number | null;
  source: "search" | "suggest";
};

/**
 * 確定した検索ログをバックエンドに送信する
 * fire-and-forget 用途: 呼び出し元が `.catch()` でエラーハンドリングすること
 */
export async function postSearchLog(payload: SearchLogPayload): Promise<void> {
  const url = `${API_URL}/api/external/v1/search-log`;
  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error(`API error: ${res.status} ${res.statusText}`);
  }
}
